import { render, staticRenderFns } from "./Nominatives.vue?vue&type=template&id=6cc6e364&"
import script from "./Nominatives.vue?vue&type=script&lang=js&"
export * from "./Nominatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports